'use client';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledEditorWrapper = styled(Box)`
  .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {
    border: none !important;
  }

  .ck-editor__editable_inline {
    min-height: 148px !important;
    height: 100% !important;
    max-height: 300px !important;
    font-size: 16px;
    line-height: 1.6;
    background-color: rgba(255, 255, 255, 0.03) !important;
    padding: 10px;
    color: white !important;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    padding-left: 32px !important;
  }

  .ck.ck-toolbar {
    background-color: rgba(255, 255, 255, 0.03) !important;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    padding: 12px !important;
    border-bottom: none !important;
  }

  .ck.ck-list {
    background-color: rgba(255, 255, 255, 0.03) !important;
  }

  .ck-rounded-corners .ck.ck-dropdown > .ck-dropdown__panel > .ck-list .ck-list__item > .ck-button {
    background-color: rgba(255, 255, 255, 0.03) !important;
  }

  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
    background-color: #0e1019 !important;
    border-color: #393a42 !important;
  }

  .ck.ck-toolbar .ck-button {
    background-color: rgba(255, 255, 255, 0.03) !important;
    border: 1px solid rgba(255, 255, 255, 0.15); /* Nút trong toolbar có màu nền khác */
    color: white !important;
  }

  .ck.ck-toolbar .ck-button:hover {
    background-color: rgba(255, 255, 255, 0.15) !important;
  }
`;
